import { environment } from "./env";

// Exchange is a static SPA with no server-rendered config, so the idle period is the same everywhere.
const idleTimeoutMinutes = 60;

const devConfig = {
  sendBirdAppId: "BF761123-7A85-4A1A-9DB3-F705FCE35626",
  featuresClientSideId: "672bb61b1738830881641a40",
};

const demoConfig = {
  sendBirdAppId: "56461A23-F956-4E35-A473-99A745025F30",
  featuresClientSideId: "68530df2e9102e093cc34748",
};

const qaConfig = {
  sendBirdAppId: "A02B95DF-9348-4DCD-8FD8-2A6F59BC4E7D",
  featuresClientSideId: "672bb5ecedf12a08738c229f",
};

const uatConfig = {
  sendBirdAppId: "56461A23-F956-4E35-A473-99A745025F30",
  featuresClientSideId: "672bb60e1d32ab0880c61501",
};

const preConfig = {
  sendBirdAppId: "A21026BF-EE37-4EFB-8ACC-F3C9BB1EE2A6",
  featuresClientSideId: "672bb60865d29c0845e4f40d",
};

const prodConfig = {
  sendBirdAppId: "714FC4C6-616C-48C3-A555-15802F4E5217",
  featuresClientSideId: "672bb5ecedf12a08738c22a0",
};

const config = {
  dev: devConfig,
  demo: demoConfig,
  qa: qaConfig,
  uat: uatConfig,
  pre: preConfig,
  prod: prodConfig,
};

let currentConfig = config[environment];

export default {
  idleTimeoutMinutes,
  sendBirdAppId: currentConfig.sendBirdAppId,
  featuresClientSideId: currentConfig.featuresClientSideId,
};
